import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { readStoredUser } from "../utils/sessionUser";
import PosPanel from "./PosPanel";
import Catalogs from "./pages/Catalogs";
import Classifications from "./pages/Classifications";
import CustomerCredit from "./pages/CustomerCredit";
import Devices from "./pages/Devices";
import Tables from "./pages/Tables";
import Orders from "./pages/Orders";
import Outlets from "./pages/Outlets";
import PaymentMethods from "./pages/PaymentMethods";
import Products from "./pages/Products";
import Sales from "./pages/Sales";
import "./pos.css";

export default function PosApp() {
  const user = readStoredUser();
  const allowedModules = Array.isArray(user?.allowed_modules) ? user.allowed_modules : [];
  const isAdmin = Number(user?.id) === 1;

  if (!isAdmin && !allowedModules.includes("pos")) {
    return <Navigate to="/select-module" replace />;
  }

  return (
    <Routes>
      <Route element={<PosPanel />}>
        <Route path="sales" element={<Sales />} />
        <Route path="orders" element={<Orders />} />
        <Route path="customer-credit" element={<CustomerCredit />} />
        <Route path="dashboard" element={<Navigate to="../sales" replace />} />
        <Route path="imports" element={<Navigate to="../sales" replace />} />
        <Route path="products" element={<Products />} />
        <Route path="classifications" element={<Classifications />} />
        <Route path="outlets" element={<Outlets />} />
        <Route path="catalogs" element={<Catalogs />} />
        <Route path="payment-methods" element={<PaymentMethods />} />
        <Route path="devices" element={<Devices />} />
        <Route path="tables" element={<Tables />} />
        <Route path="*" element={<Navigate to="sales" replace />} />
      </Route>
    </Routes>
  );
}
